interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
}: SEOMetaProps) {
  const fullTitle = `${title} - 吃瓜网`;
  const defaultImage = 'https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20entertainment%20news%20website%20with%20warm%20orange%20and%20red%20accents%2C%20bold%20typography%2C%20clean%20layout%2C%20news%20cards%2C%20social%20media%20style%2C%20professional%20yet%20vibrant&width=1200&height=630&seq=og-default&orientation=landscape';
  const image = ogImage || defaultImage;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:site_name" content="吃瓜网" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {articlePublishedTime && <meta property="article:published_time" content={articlePublishedTime} />}
      {articleModifiedTime && <meta property="article:modified_time" content={articleModifiedTime} />}
      {articleAuthor && <meta property="article:author" content={articleAuthor} />}
    </>
  );
}